import { List } from 'immutable';
import { lruMemoize } from 'reselect';

import {
    isResourceLoading,
    isResourceFailed,
    isResourceComplete,
    getResourceError,
    getResourceTotal,
    getResourcePage,
} from './common';

const isImpactingPoliciesLoading = lruMemoize(isResourceLoading);
const getImpactingPoliciesTotal = getResourceTotal;
const getImpactingPoliciesPage = getResourcePage;
const getImpactingPolicies = lruMemoize(
    (data) => data.get('impacting_policies', List()),
);

const getImpactingPolicy = lruMemoize((data) => data.get('impacting_policy'));
const isImpactingPolicyLoading = lruMemoize(isResourceLoading);
const isImpactingPolicyFailed = lruMemoize(isResourceFailed);
const isImpactingPolicyComplete = lruMemoize(isResourceComplete);
const getImpactingPolicyError = lruMemoize(getResourceError);
const getImpactingPolicySlug = lruMemoize((data) => data.getIn(['impacting_policy', 'slug']));
const getImpactingPolicyTitle = lruMemoize((data) => data.getIn(['impacting_policy', 'title']));
const getImpactingPolicyReadByUser = lruMemoize((data) => data.getIn(['impacting_policy', 'read_by_user']));

export {
    isImpactingPoliciesLoading,
    getImpactingPoliciesTotal,
    getImpactingPoliciesPage,
    getImpactingPolicies,
    getImpactingPolicy,
    isImpactingPolicyLoading,
    isImpactingPolicyFailed,
    isImpactingPolicyComplete,
    getImpactingPolicyError,
    getImpactingPolicySlug,
    getImpactingPolicyTitle,
    getImpactingPolicyReadByUser,
};
